import EditPage from "../components/EditPage";
import PageHeaderEdit from "../components/PageHeaderEdit";
import PageInfoListEdit from "../components/PageInfoListEdit";
import AddressEdit from "../components/AddressEdit";
import { UploadFolderIdProvider } from "../util/UploadFolderIdContext";

export default function Kontakt() {
    const uploadFolderId = '1KGLwdExpkoNErDQ2vt1hu3JUE6K9vO79';
    return (
        <UploadFolderIdProvider folderId={uploadFolderId}>
            <EditPage apiPath="page/Kontakt">
                <PageHeaderEdit sectionKey="PageHeader" />
                <AddressEdit sectionKey="Sec1"/>
                <PageInfoListEdit sectionKey="Sec2"/>
                <PageInfoListEdit sectionKey="Sec3"/>
            </EditPage>
        </UploadFolderIdProvider>
    );
}